'use strict';

import BaseService from './base.service';

class CollectionsService extends BaseService {
    /* @ngInject */
    constructor(
        Collection,
        CollectionSpending,
        SegaUser
    ) {
        super(Collection, SegaUser);
        Object.assign(this, {
            CollectionSpending
        });
    }

    addSpending(opts = {collection: null, description: '', amount: 0}) {
        let spending = new this.CollectionSpending({
            collectionId: opts.collection.id,
            description: opts.description,
            amount: opts.amount
        });
        return spending.$save();
    }

    deleteSpending(opts = {spending: null}) {
        return this.CollectionSpending.deleteById({
            id: opts.spending.id
        }).$promise;
    }

    getDraft(opts = {employeeId: null, reset: false}) {
        return this.Model.getDraftCollection({
            employeeId: opts.employeeId,
            reset: opts.reset
        }).$promise;
    }

    removeReceipt(opts = {collectionId: 0, receiptId: 0}) {
        return this.Model.removeReceipt({
            collectionId: opts.collectionId,
            receiptId: opts.receiptId
        }).$promise;
    }

    approve(opts = {id: 0}) {
        return this.Model.approve({
            id: opts.id
        }).$promise;
    }

    disapprove(opts = {id: 0}) {
        return this.Model.disapprove({
            id: opts.id
        }).$promise;
    }

    sendToTreasury(opts = {id: 0}) {
        return this.Model.sendToTreasury({
            id: opts.id
        }).$promise;
    }

    reject(opts = {id: 0, reason: ''}) {
        return this.Model.reject({
            id: opts.id,
            reason: opts.reason
        }).$promise;
    }

    removeSpending(opts = {collectionId: 0, spendingId: 0}) {
        return this.Model.removeSpending({
            collectionId: opts.collectionId,
            spendingId: opts.spendingId
        }).$promise;
    }

    removeOperativeSpending(opts = {collectionId: 0, oSpendingId: 0}) {
        return this.Model.removeOperativeSpending({
            collectionId: opts.collectionId,
            oSpendingId: opts.oSpendingId
        }).$promise;
    }

    removeCashboxTransfer(opts = {collectionId: 0, cashboxTransferId: 0}) {
        return this.Model.removeCashboxTransfer({
            collectionId: opts.collectionId,
            cashboxTransferId: opts.cashboxTransferId
        }).$promise;
    }


    sendToMain(opts = {
        collectionIds: [],
        amount: 0,
        comments: ''
    }) {
        return this.Model.sendToMain(opts).$promise;
    }
}

export default CollectionsService;
